// Primary intent pill. Replaces the v2 CategoryPill ("Blocked"/"Spec"/...).
// The PRIMARY label is now the attack intent (Path Traversal, SSRF, …)
// — the customer-perceived "what" of the event. The action (Blocked
// vs Challenged) is rendered separately as an action chip.

import React from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import * as LucideIcons from "lucide-react";
import { severityPalette, intentIconName } from "../../../../../utils/wafEventV3";
import colors from "../../../../../utils/colors";

function IconFor({ name, size = 13, color }) {
  const Cmp = LucideIcons[name] || LucideIcons.Shield;
  return <Cmp size={size} color={color} />;
}

export default function IntentPill({ primaryIntent, severity, cweId, compact = false }) {
  const palette = severityPalette(severity);
  const label = (primaryIntent && primaryIntent.intent_name) || "Suspicious request";
  const iconName = intentIconName(primaryIntent && primaryIntent.intent_id);
  return (
    <Tooltip title={cweId ? `${label} · ${cweId}` : label}>
      <Box sx={{
        display: "inline-flex", alignItems: "center", gap: 0.5,
        px: 1, height: compact ? 20 : 22, borderRadius: 999,
        backgroundColor: palette.bg, color: palette.fg,
        border: `1px solid ${palette.fg}33`,
        fontSize: compact ? 11 : 11.5, fontWeight: 500, whiteSpace: "nowrap",
        maxWidth: 280,
      }}>
        <IconFor name={iconName} size={compact ? 11 : 13} color={palette.fg} />
        <Typography component="span" noWrap sx={{
          fontSize: compact ? 11 : 11.5, color: palette.fg, lineHeight: 1, fontWeight: 500,
        }}>{label}</Typography>
        {cweId && !compact && (
          <Typography component="span" sx={{
            fontSize: 10.5, color: colors.neutral[600], ml: 0.25,
          }}>{cweId}</Typography>
        )}
      </Box>
    </Tooltip>
  );
}
